export type QuizBankSection = 'imagery' | 'theory' | 'practice';

export interface QuizBankQuestion {
  id: string;
  section: QuizBankSection;
  category: string;
  text: string;
  options: string[];
  correctAnswers: number[];
  explanation: string;
}

export const quizBankQuestions: QuizBankQuestion[] = [
  {
    "id": "I001",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「甲」天干的性情描述？",
    "options": [
      "精致敏锐、洞察力强，讲话带锋芒。",
      "外柔内谋、善统筹策划，处理关系细致。",
      "庄重威仪、城府深、偏冷感，易显掌控姿态。",
      "情绪细腻多思、多情敏感，也主困顿感。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "甲木为阳木，象征参天大树、栋梁之材。性情庄重威仪、城府较深，在婚恋中易显掌控姿态，对伴侣要求高，感情表达偏内敛冷感。"
  },
  {
    "id": "I002",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「乙」天干的性情描述？",
    "options": [
      "温柔细腻、重体贴与美感，常见艺术气质。",
      "敦厚守信、重资源与平台，做事偏稳。",
      "庄重威仪、城府深、偏冷感，易显掌控姿态。",
      "热情外放、行动快、脾气急，重表达与存在感。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "乙木为阴木，象征花草藤蔓、柔韧之木。性情温柔细腻、重体贴与美感，常见艺术气质，善于察言观色，感情中注重浪漫与情调。"
  },
  {
    "id": "I003",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「丙」天干的性情描述？",
    "options": [
      "庄重威仪、城府深、偏冷感，易显掌控姿态。",
      "热情外放、行动快、脾气急，重表达与存在感。",
      "刚直果断、重规则与执行，亦主压力阻碍。",
      "敦厚守信、重资源与平台，做事偏稳。"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "丙火为阳火，象征太阳、熊熊烈火。性情热情外放、行动快、脾气急，重表达与存在感，爱得轰轰烈烈，但也容易情绪化。"
  },
  {
    "id": "I004",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「丁」天干的性情描述？",
    "options": [
      "精致敏锐、洞察力强，讲话带锋芒。",
      "刚直果断、重规则与执行，亦主压力阻碍。",
      "外柔内谋、善统筹策划，处理关系细致。",
      "敦厚守信、重资源与平台，做事偏稳。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "丁火为阴火，象征烛光星火、温柔之光。性情精致敏锐、洞察力强，讲话带锋芒，善于发现问题，感情中注重细节与品质。"
  },
  {
    "id": "I005",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「戊」天干的性情描述？",
    "options": [
      "敦厚守信、重资源与平台，做事偏稳。",
      "温柔细腻、重体贴与美感，常见艺术气质。",
      "情绪细腻多思、多情敏感，也主困顿感。",
      "庄重威仪、城府深、偏冷感，易显掌控姿态。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "戊土为阳土，象征高山堤坝、厚重之土。性情敦厚守信、重资源与平台，做事偏稳，给人安全感，感情中踏实可靠但缺乏浪漫。"
  },
  {
    "id": "I006",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「己」天干的性情描述？",
    "options": [
      "外柔内谋、善统筹策划，处理关系细致。",
      "精致敏锐、洞察力强，讲话带锋芒。",
      "刚直果断、重规则与执行，亦主压力阻碍。",
      "思维活络、适应性强，但容易摇摆迷茫。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "己土为阴土，象征田园沃土、滋养之土。性情外柔内谋、善统筹策划，处理关系细致周到，城府较深但外表温和。"
  },
  {
    "id": "I007",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「庚」天干的性情描述？",
    "options": [
      "刚直果断、重规则与执行，亦主压力阻碍。",
      "外柔内谋、善统筹策划，处理关系细致。",
      "热情外放、行动快、脾气急，重表达与存在感。",
      "敏感偏激、变化性强，易走极端判断。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "庚金为阳金，象征刀剑矿石、刚硬之金。性情刚直果断、重规则与执行，亦主压力阻碍，爱恨分明，感情中缺乏柔情。"
  },
  {
    "id": "I008",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「辛」天干的性情描述？",
    "options": [
      "情绪细腻多思、多情敏感，也主困顿感。",
      "外柔内谋、善统筹策划，处理关系细致。",
      "敏感偏激、变化性强，易走极端判断。",
      "思维活络、适应性强，但容易摇摆迷茫。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "辛金为阴金，象征首饰珠宝、精致之金。性情敏感偏激、变化性强，易走极端判断，情感起伏大，追求完美爱情。"
  },
  {
    "id": "I009",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「壬」天干的性情描述？",
    "options": [
      "热情外放、行动快、脾气急，重表达与存在感。",
      "刚直果断、重规则与执行，亦主压力阻碍。",
      "思维活络、适应性强，但容易摇摆迷茫。",
      "敦厚守信、重资源与平台，做事偏稳。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "壬水为阳水，象征江河大海、奔流之水。性情思维活络、适应性强，但容易摇摆迷茫，变化多端，感情中缺乏定力。"
  },
  {
    "id": "I010",
    "section": "imagery",
    "category": "天干象意",
    "text": "在婚恋象意中，以下哪项最符合「癸」天干的性情描述？",
    "options": [
      "外柔内谋、善统筹策划，处理关系细致。",
      "庄重威仪、城府深、偏冷感，易显掌控姿态。",
      "情绪细腻多思、多情敏感，也主困顿感。",
      "思维活络、适应性强，但容易摇摆迷茫。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "癸水为阴水，象征雨露溪流、温柔之水。性情情绪细腻多思、多情敏感，也主困顿感，感情丰富但易陷入情感纠葛。"
  },
  {
    "id": "I011",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「值符」在感情关系中的象意表现？",
    "options": [
      "重连接与和合，利关系修复与成婚。",
      "推进慢但稳，重落地与长期经营。",
      "隐秘性强，易出现暧昧和私下动作。",
      "重体面与格局，追求名望和品质感。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "八神用于判断关系心态与行为风格，「值符」有其固定倾向。"
  },
  {
    "id": "I012",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「腾蛇」在感情关系中的象意表现？",
    "options": [
      "推进慢但稳，重落地与长期经营。",
      "隐秘性强，易出现暧昧和私下动作。",
      "目标高、节奏快，易理想化和高估。",
      "情绪反复、纠缠感重，关系易拉扯。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "八神用于判断关系心态与行为风格，「腾蛇」有其固定倾向。"
  },
  {
    "id": "I013",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「太阴」在感情关系中的象意表现？",
    "options": [
      "隐秘性强，易出现暧昧和私下动作。",
      "重体面与格局，追求名望和品质感。",
      "表达含蓄、慢热细腻，常见暗恋与隐忍。",
      "目标高、节奏快，易理想化和高估。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "八神用于判断关系心态与行为风格，「太阴」有其固定倾向。"
  },
  {
    "id": "I014",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「六合」在感情关系中的象意表现？",
    "options": [
      "表达含蓄、慢热细腻，常见暗恋与隐忍。",
      "情绪浓烈、说话直接，冲突感偏高。",
      "情绪反复、纠缠感重，关系易拉扯。",
      "重连接与和合，利关系修复与成婚。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "八神用于判断关系心态与行为风格，「六合」有其固定倾向。"
  },
  {
    "id": "I015",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「白虎」在感情关系中的象意表现？",
    "options": [
      "重体面与格局，追求名望和品质感。",
      "重连接与和合，利关系修复与成婚。",
      "情绪浓烈、说话直接，冲突感偏高。",
      "情绪反复、纠缠感重，关系易拉扯。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "八神用于判断关系心态与行为风格，「白虎」有其固定倾向。"
  },
  {
    "id": "I016",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「玄武」在感情关系中的象意表现？",
    "options": [
      "隐秘性强，易出现暧昧和私下动作。",
      "目标高、节奏快，易理想化和高估。",
      "重体面与格局，追求名望和品质感。",
      "表达含蓄、慢热细腻，常见暗恋与隐忍。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "八神用于判断关系心态与行为风格，「玄武」有其固定倾向。"
  },
  {
    "id": "I017",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「九地」在感情关系中的象意表现？",
    "options": [
      "目标高、节奏快，易理想化和高估。",
      "重连接与和合，利关系修复与成婚。",
      "推进慢但稳，重落地与长期经营。",
      "情绪反复、纠缠感重，关系易拉扯。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "八神用于判断关系心态与行为风格，「九地」有其固定倾向。"
  },
  {
    "id": "I018",
    "section": "imagery",
    "category": "八神象意",
    "text": "下列哪项更贴近「九天」在感情关系中的象意表现？",
    "options": [
      "目标高、节奏快，易理想化和高估。",
      "重体面与格局，追求名望和品质感。",
      "表达含蓄、慢热细腻，常见暗恋与隐忍。",
      "情绪浓烈、说话直接，冲突感偏高。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "八神用于判断关系心态与行为风格，「九天」有其固定倾向。"
  },
{
    "id": "I019",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「开门落震巽」形成门迫，其核心象意是？",
    "options": [
      "事业推进受阻，项目难顺畅落地",
      "增长乏力，利润与发展都不理想",
      "恢复力下降，易疲惫且休整效果差",
      "前景包装受损，文书合同隐患增多"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "开门属金，震巽属木，金克木形成门迫。开门主事业开拓，门迫则推进受阻、项目落地困难。"
  },
  {
    "id": "I020",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「惊门落震巽」形成门迫，其核心象意是？",
    "options": [
      "发声宣传受阻，易遇流言与误解",
      "事业推进受阻，项目难顺畅落地",
      "竞争受挫，易有损失或受伤风险",
      "恢复力下降，易疲惫且休整效果差"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "惊门属金，震巽属木，金克木形成门迫。惊门主发声宣传，门迫则传播受阻、易遭流言误解。"
  },
  {
    "id": "I021",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「伤门落坤艮」形成门迫，其核心象意是？",
    "options": [
      "事业推进受阻，项目难顺畅落地",
      "恢复力下降，易疲惫且休整效果差",
      "发声宣传受阻，易遇流言与误解",
      "竞争受挫，易有损失或受伤风险"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "伤门属木，坤艮属土，木克土形成门迫。伤门主竞争进取，门迫则竞争受损、易有伤病风险。"
  },
  {
    "id": "I022",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「杜门落坤艮」形成门迫，其核心象意是？",
    "options": [
      "事务僵滞停顿，终结感增强",
      "前景包装受损，文书合同隐患增多",
      "保密失效，隐藏问题容易暴露",
      "恢复力下降，易疲惫且休整效果差"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "杜门属木，坤艮属土，木克土形成门迫。杜门主隐藏保密，门迫则保密失效、隐秘容易暴露。"
  },
  {
    "id": "I023",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「休门落离」形成门迫，其核心象意是？",
    "options": [
      "发声宣传受阻，易遇流言与误解",
      "恢复力下降，易疲惫且休整效果差",
      "事务僵滞停顿，终结感增强",
      "增长乏力，利润与发展都不理想"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "休门属水，离属火，水克火形成门迫。休门主休养恢复，门迫则恢复力下降、休整效果不佳。"
  },
  {
    "id": "I024",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「生门落坎」形成门迫，其核心象意是？",
    "options": [
      "增长乏力，利润与发展都不理想",
      "竞争受挫，易有损失或受伤风险",
      "事务僵滞停顿，终结感增强",
      "事业推进受阻，项目难顺畅落地"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "生门属土，坎属水，土克水形成门迫。生门主生长发展，门迫则增长乏力、利润不理想。"
  },
  {
    "id": "I025",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「死门落坎」形成门迫，其核心象意是？",
    "options": [
      "竞争受挫，易有损失或受伤风险",
      "恢复力下降，易疲惫且休整效果差",
      "事业推进受阻，项目难顺畅落地",
      "事务僵滞停顿，终结感增强"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "死门属土，坎属水，土克水形成门迫。死门主终结停滞，门迫则事务僵滞、终结感更强。"
  },
  {
    "id": "I026",
    "section": "imagery",
    "category": "门迫象意",
    "text": "「景门落乾兑」形成门迫，其核心象意是？",
    "options": [
      "前景包装受损，文书合同隐患增多",
      "发声宣传受阻，易遇流言与误解",
      "保密失效，隐藏问题容易暴露",
      "事务僵滞停顿，终结感增强"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "景门属火，乾兑属金，火克金形成门迫。景门主前景文书，门迫则前景包装受损、文书有隐患。"
  },
  {
    "id": "I020",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "惊门落震巽：发声宣传受阻，易遇流言与误解。",
      "惊门落震巽：事业推进受阻，项目难顺畅落地。",
      "惊门落震巽：竞争受挫，易有损失或受伤风险。",
      "惊门落震巽：恢复力下降，易疲惫且休整效果差。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I021",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "伤门落坤艮：事业推进受阻，项目难顺畅落地。",
      "伤门落坤艮：恢复力下降，易疲惫且休整效果差。",
      "伤门落坤艮：发声宣传受阻，易遇流言与误解。",
      "伤门落坤艮：竞争受挫，易有损失或受伤风险。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I022",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "杜门落坤艮：事务僵滞停顿，终结感增强。",
      "杜门落坤艮：前景包装受损，文书合同隐患增多。",
      "杜门落坤艮：保密失效，隐藏问题容易暴露。",
      "杜门落坤艮：恢复力下降，易疲惫且休整效果差。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I023",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "休门落离：发声宣传受阻，易遇流言与误解。",
      "休门落离：恢复力下降，易疲惫且休整效果差。",
      "休门落离：事务僵滞停顿，终结感增强。",
      "休门落离：增长乏力，利润与发展都不理想。"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I024",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "生门落坎：增长乏力，利润与发展都不理想。",
      "生门落坎：竞争受挫，易有损失或受伤风险。",
      "生门落坎：事务僵滞停顿，终结感增强。",
      "生门落坎：事业推进受阻，项目难顺畅落地。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I025",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "死门落坎：竞争受挫，易有损失或受伤风险。",
      "死门落坎：恢复力下降，易疲惫且休整效果差。",
      "死门落坎：事业推进受阻，项目难顺畅落地。",
      "死门落坎：事务僵滞停顿，终结感增强。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I026",
    "section": "imagery",
    "category": "门迫象意",
    "text": "以下哪组“门+宫”与门迫象意匹配正确？",
    "options": [
      "景门落乾兑：前景包装受损，文书合同隐患增多。",
      "景门落乾兑：发声宣传受阻，易遇流言与误解。",
      "景门落乾兑：保密失效，隐藏问题容易暴露。",
      "景门落乾兑：事务僵滞停顿，终结感增强。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "门迫属于“门克宫为破”，需把组合与对应象意准确匹配。"
  },
  {
    "id": "I027",
    "section": "imagery",
    "category": "四害象意",
    "text": "关于击刑的核心象意，哪一项更准确？",
    "options": [
      "击刑等同入墓，核心是事物被隐藏封存。",
      "击刑偏“内伤”，常见牵扯、别扭、自耗和破损。",
      "击刑主“外界托举”，多为贵人直接抬升。",
      "击刑等同空亡，核心是信息向对宫转移。"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "基础章节明确将击刑定义为内部冲突与自我消耗，不是外部扶持。"
  },
  {
    "id": "I028",
    "section": "imagery",
    "category": "四害象意",
    "text": "关于门迫的理解，哪项正确？",
    "options": [
      "门迫是“门克宫”，主发挥受阻、做事被掣肘。",
      "门迫只在婚姻局有效，事业局不看门迫。",
      "门迫是“宫克门”，主效率提升、推进更快。",
      "门迫出现时一定代表大吉，可直接放大判断。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "门迫本质是门克宫，能量被压制，属于不利因素。"
  },
  {
    "id": "I029",
    "section": "imagery",
    "category": "四害象意",
    "text": "空亡在断象中的关键点是什么？",
    "options": [
      "空亡即完全无效，直接忽略该宫即可。",
      "空亡等于伏吟，二者断法完全一致。",
      "空亡是能量转移，不是彻底消失，需转对宫看主信息。",
      "空亡只看本宫，不需要转宫。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "空亡约 80% 信息转移至对宫，本宫仅剩少量残留。"
  },
  {
    "id": "I030",
    "section": "imagery",
    "category": "四害象意",
    "text": "入墓在实务中的典型表现是？",
    "options": [
      "主“被藏、被压、退居二线”，事情不易外显推进。",
      "主信息转对宫，和空亡完全相同。",
      "主口舌冲突加剧，和惊门同义。",
      "主高曝光高热度，事项加速外放。"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "入墓强调“收纳和封存”，常见停滞、积压、隐退。"
  },
  {
    "id": "I031",
    "section": "imagery",
    "category": "四害象意",
    "text": "关于四害强度的说法，哪项正确？",
    "options": [
      "四害强度都一样，统一按 20% 损失计算。",
      "击刑、门迫约损 50%；空亡、入墓约损 80%。",
      "空亡不损能量，只影响主观情绪。",
      "击刑和门迫各损 80%，空亡入墓各损 50%。"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "课程里对四害损耗有明确比例，判断轻重需按该比例。"
  },
  {
    "id": "I032",
    "section": "imagery",
    "category": "四害象意",
    "text": "门迫与击刑同宫时，最稳妥的处理是？",
    "options": [
      "两者会互相抵消，可按无害宫位处理。",
      "只看门迫，击刑可忽略。",
      "只看击刑，门迫可忽略。",
      "先按明显受损处理，剩余能量大幅下降，不可乐观放大。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "两害叠加是减益关系，不能用“抵消”逻辑。"
  },
  {
    "id": "I033",
    "section": "imagery",
    "category": "四害象意",
    "text": "如果门迫击刑后再叠空亡/入墓，通常意味着什么？",
    "options": [
      "代表信息更集中，断语可以更激进。",
      "仅影响外观包装，不影响实质结果。",
      "该宫接近“瘫痪”，判断需极度谨慎并结合转宫/应期。",
      "说明宫位自动转吉，适合直接定成。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "多害叠加属于重损格局，常见推进困难与显化弱。"
  },
  {
    "id": "I034",
    "section": "imagery",
    "category": "四害象意",
    "text": "“宫好往好断，宫不好往坏断”主要对应哪类基础判断？",
    "options": [
      "先看求测人情绪，再决定宫位好坏。",
      "先看宫位是否遭四害，再决定断语方向与力度。",
      "先看文案风格，再决定断语方向。",
      "先看是否有直符，再完全忽略四害。"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "四害是底线筛查规则，不应被跳过。"
  },
  {
    "id": "T001",
    "section": "theory",
    "category": "四纲取用",
    "text": "在四纲中，通常代表“大领导、大环境、政策趋势”的是？",
    "options": [
      "月干",
      "时干",
      "日干",
      "年干"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "年干对应最高层环境与外部大势。"
  },
  {
    "id": "T002",
    "section": "theory",
    "category": "四纲取用",
    "text": "在四纲中，通常代表“所问之事、未来走势”的是？",
    "options": [
      "时干",
      "年干",
      "月干",
      "日干"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "时干承载事体状态与后续走向。"
  },
  {
    "id": "T003",
    "section": "theory",
    "category": "四纲取用",
    "text": "当面测时，求测人本人优先取哪一干？",
    "options": [
      "日干",
      "月干",
      "年干",
      "时干"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "当面同频，日干为本人主锚点。"
  },
  {
    "id": "T004",
    "section": "theory",
    "category": "四纲取用",
    "text": "电话测/网测时，求测人本人优先取哪一干？",
    "options": [
      "时干",
      "月干",
      "年干",
      "日干"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "远程不在场时，以月干代求测主体。"
  },
  {
    "id": "T005",
    "section": "theory",
    "category": "六亲代问",
    "text": "代子女问事时，常规优先取哪一干？",
    "options": [
      "月干",
      "日干",
      "时干",
      "年干"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "时干常对应晚辈、子女与后续事项。"
  },
  {
    "id": "T006",
    "section": "theory",
    "category": "六亲代问",
    "text": "代父母问事时，常规优先取哪一干？",
    "options": [
      "时干",
      "年干",
      "月干",
      "日干"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "年干对应该系统中的长辈层。"
  },
  {
    "id": "T007",
    "section": "theory",
    "category": "六亲代问",
    "text": "代兄弟姐妹问事时，常规优先取哪一干？",
    "options": [
      "年干",
      "时干",
      "日干",
      "月干"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "月干对应同辈、同层关系。"
  },
  {
    "id": "T008",
    "section": "theory",
    "category": "阴阳天干",
    "text": "下列哪组全部属于阳干？",
    "options": [
      "乙、丁、己、辛、癸",
      "庚、辛、壬、癸、甲",
      "甲、乙、丙、丁、戊",
      "甲、丙、戊、庚、壬"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "阳干固定为甲丙戊庚壬。"
  },
  {
    "id": "T009",
    "section": "theory",
    "category": "阴阳天干",
    "text": "下列哪组全部属于阴干？",
    "options": [
      "乙、丙、丁、戊、己",
      "辛、壬、癸、甲、乙",
      "甲、丙、戊、庚、壬",
      "乙、丁、己、辛、癸"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "阴干固定为乙丁己辛癸。"
  },
  {
    "id": "T010",
    "section": "theory",
    "category": "年命基础",
    "text": "出生年尾数为 4 时，年命天干记作？",
    "options": [
      "丙",
      "乙",
      "甲",
      "戊"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "年命记法中，尾数 4 对应甲。"
  },
  {
    "id": "T011",
    "section": "theory",
    "category": "年命基础",
    "text": "出生年尾数为 9 时，年命天干记作？",
    "options": [
      "己",
      "辛",
      "庚",
      "癸"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "年命记法中，尾数 9 对应己。"
  },
  {
    "id": "T012",
    "section": "theory",
    "category": "四害判别",
    "text": "在四害中，通常按约 50% 损耗处理的是？",
    "options": [
      "击刑与空亡",
      "门迫与入墓",
      "击刑与门迫",
      "空亡与入墓"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "击刑、门迫属中度损耗。"
  },
  {
    "id": "T013",
    "section": "theory",
    "category": "四害判别",
    "text": "在四害中，通常按约 80% 损耗处理的是？",
    "options": [
      "空亡与入墓",
      "击刑与门迫",
      "击刑与空亡",
      "门迫与入墓"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "空亡、入墓属重度损耗。"
  },
  {
    "id": "T014",
    "section": "theory",
    "category": "击刑规则",
    "text": "关于击刑，以下哪项正确？",
    "options": [
      "丁、丙、乙三奇通常不论击刑。",
      "只有甲会击刑",
      "丁、丙、乙三奇最易击刑",
      "击刑只在择吉中使用"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "基础规则明确三奇不论击刑。"
  },
  {
    "id": "T015",
    "section": "theory",
    "category": "门迫规则",
    "text": "门迫的判定核心是？",
    "options": [
      "八神克九星为迫",
      "门克宫为迫",
      "宫克门为迫",
      "天盘克地盘为迫"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "门迫定义即八门克九宫。"
  },
  {
    "id": "T016",
    "section": "theory",
    "category": "空亡规则",
    "text": "空亡在实务中的第一动作应是？",
    "options": [
      "忽略该宫全部信息",
      "先跳过等应期再看",
      "只看本宫不转宫",
      "转对宫复核主信息"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "空亡主转移，必须转宫。"
  },
  {
    "id": "T017",
    "section": "theory",
    "category": "空亡规则",
    "text": "关于空亡应期，“非填即冲”中的“冲”通常指？",
    "options": [
      "值符落宫时自动触发",
      "只在月令变化时触发",
      "本宫地支重复两次",
      "对宫地支到位触发"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "填看本宫，冲看对宫。"
  },
  {
    "id": "T018",
    "section": "theory",
    "category": "空亡规则",
    "text": "若戌亥空亡，按冲实应期优先关注哪组地支？",
    "options": [
      "辰巳",
      "寅卯",
      "午未",
      "申酉"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "戌亥的对冲为辰巳。"
  },
  {
    "id": "T019",
    "section": "theory",
    "category": "入墓口诀",
    "text": "“甲癸入___”正确补全应为？",
    "options": [
      "乾",
      "巽",
      "坤",
      "艮"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "入墓口诀：甲癸入坤。"
  },
  {
    "id": "T020",
    "section": "theory",
    "category": "入墓口诀",
    "text": "“乙丙戊入___”正确补全应为？",
    "options": [
      "巽",
      "乾",
      "坤",
      "艮"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "入墓口诀：乙丙戊入乾。"
  },
  {
    "id": "T021",
    "section": "theory",
    "category": "入墓口诀",
    "text": "“丁己庚入___”正确补全应为？",
    "options": [
      "艮",
      "坤",
      "乾",
      "巽"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "入墓口诀：丁己庚入艮。"
  },
  {
    "id": "T022",
    "section": "theory",
    "category": "入墓口诀",
    "text": "“辛壬在___”正确补全应为？",
    "options": [
      "坤",
      "乾",
      "离",
      "巽"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "入墓口诀：辛壬在巽。"
  },
  {
    "id": "T023",
    "section": "theory",
    "category": "反断规则",
    "text": "“反断局”通常在什么条件下考虑？",
    "options": [
      "只要有直符就反断",
      "只要是婚姻局就反断",
      "四纲天干落宫全坏时",
      "只要出现空亡就反断"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "四纲全坏是反断触发的关键前提。"
  },
  {
    "id": "T024",
    "section": "theory",
    "category": "翻宫规则",
    "text": "地盘翻天盘，常用于优先观察什么？",
    "options": [
      "只看外貌",
      "只看财务流水",
      "过去根源",
      "事情未来走向"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "地盘偏基础与过去，翻到天盘用于看未来显化。"
  },
  {
    "id": "T025",
    "section": "theory",
    "category": "翻宫规则",
    "text": "天盘翻地盘，常用于优先观察什么？",
    "options": [
      "只看求测人性格",
      "未来高峰时间",
      "事情来龙去脉与过去状态",
      "仅用于学业预测"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "天翻地用于追溯过去脉络。"
  },
  {
    "id": "T026",
    "section": "theory",
    "category": "翻宫规则",
    "text": "时干地盘翻到天盘，在“事情选择”中通常对应？",
    "options": [
      "第一选择",
      "第二选择",
      "无效信息",
      "第三选择"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "课程中按翻宫顺序看一、二、三、四选择。"
  },
  {
    "id": "T027",
    "section": "theory",
    "category": "内外盘",
    "text": "用神落内盘（坎艮震巽）时，一般倾向于？",
    "options": [
      "远、慢、外地",
      "只代表情绪不代表速度",
      "慢但必成",
      "近、快、本地"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "内盘通常对应近场与快节奏。"
  },
  {
    "id": "T028",
    "section": "theory",
    "category": "内外盘",
    "text": "用神落外盘（离坤兑乾）时，一般倾向于？",
    "options": [
      "近、快、本地",
      "只主财务不主距离",
      "必然失败",
      "远、慢、外地"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "外盘多对应远场和相对慢节奏。"
  },
  {
    "id": "T029",
    "section": "theory",
    "category": "马星应期",
    "text": "下列哪条马星规则是正确的？",
    "options": [
      "申子辰马在亥",
      "申子辰马在午",
      "申子辰马在寅",
      "申子辰马在巳"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "四组三合局对应马星位置需熟记。"
  },
  {
    "id": "T030",
    "section": "theory",
    "category": "马星应期",
    "text": "关于马星，哪项理解更准确？",
    "options": [
      "马星只主感情，不主事业",
      "马星只在年柱有效",
      "马星出现必然停滞",
      "马星主变动与速度，临马常见事态加速。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "马星是典型动态符号。"
  },
  {
    "id": "T031",
    "section": "theory",
    "category": "旺衰判断",
    "text": "十二长生里，通常视作能量较强的是？",
    "options": [
      "墓、绝",
      "衰、胎",
      "临官、帝旺",
      "沐浴、病"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "临官帝旺代表生机与执行力较强。"
  },
  {
    "id": "T032",
    "section": "theory",
    "category": "通气规则",
    "text": "关于通气，哪项符合课程逻辑？",
    "options": [
      "有共同符号且能量层次接近，更易沟通与稳定。",
      "通气与四害无关",
      "通气只看值符不看宫位",
      "只要有共同符号就一定无四害"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "通气强调共同符号与能量对等，不是单指标。"
  },
  {
    "id": "T033",
    "section": "theory",
    "category": "叠加效应",
    "text": "门迫与击刑并存时，剩余能量通常按哪一档位近似处理？",
    "options": [
      "约 80%",
      "约 25%",
      "约 45%",
      "约 60%"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "两种 50% 级损耗叠加后，剩余显著下降。"
  },
  {
    "id": "T034",
    "section": "theory",
    "category": "叠加效应",
    "text": "在“门迫+击刑”基础上再叠空亡/入墓时，剩余能量通常接近？",
    "options": [
      "约 70%",
      "约 50%",
      "约 5%",
      "约 35%"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "多害叠加后宫位接近瘫痪状态。"
  },
  {
    "id": "P001",
    "section": "practice",
    "category": "场景取用",
    "text": "远程来访者在微信上问婚姻，你第一步更稳妥的取用是？",
    "options": [
      "直接以日干定位求测人，不看是否当面。",
      "先看年干断结果，其他全部省略。",
      "先以月干定位求测人，再看其合干与关系宫位。",
      "先看值符即可，不需要四纲。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "网测不在场，主体先取月干，再叠加婚姻规则。"
  },
  {
    "id": "P002",
    "section": "practice",
    "category": "场景取用",
    "text": "当面来访问求职方向，哪个起手顺序更专业？",
    "options": [
      "先看年干定岗位，不看日时。",
      "直接按主观偏好给行业建议。",
      "先看日干天盘定长期适配，再看时干天盘定当下选择。",
      "只看门星神，不看四纲。"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "事业章节明确区分“长期适配”和“当下最优”。"
  },
  {
    "id": "P003",
    "section": "practice",
    "category": "空亡转宫",
    "text": "你发现核心用神落空亡，正确处理是？",
    "options": [
      "只盯本宫，不转宫。",
      "立刻反断，不需要其他条件。",
      "判为无事发生，直接结束。",
      "本宫只作残留参考，转对宫提取主信息再断。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "空亡主转移，不是“信息清零”。"
  },
  {
    "id": "P004",
    "section": "practice",
    "category": "通气判断",
    "text": "夫妻宫相生且有共同天干，常见关系状态更接近？",
    "options": [
      "必然没有现实压力",
      "支持感较强、沟通顺畅，关系可持续经营。",
      "必定马上离婚",
      "只会短期激情，难以长期"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "相生+共同符号通常是较好的协同信号。"
  },
  {
    "id": "P005",
    "section": "practice",
    "category": "通气判断",
    "text": "夫妻宫相生但无共同符号，咨询时更应提醒什么？",
    "options": [
      "说明不用沟通也能长期稳定",
      "可能出现“费力不讨好”，要补共同话题和沟通机制。",
      "说明必须立刻分手",
      "说明双方没有任何感情基础"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "相生不代表自动共鸣，缺共同符号常是隐患。"
  },
  {
    "id": "P006",
    "section": "practice",
    "category": "通气判断",
    "text": "两宫相克但有共同符号时，较稳妥的解读是？",
    "options": [
      "相克就等于绝对无缘",
      "相克时共同符号无意义",
      "有共同符号就一定甜蜜无冲突",
      "关系有约束与摩擦，但仍有责任连接，未必立断。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "相克并不自动终局，连接质量同样关键。"
  },
  {
    "id": "P007",
    "section": "practice",
    "category": "通气判断",
    "text": "两宫相克且无共同符号，通常更容易出现？",
    "options": [
      "与宫位生克无关，完全看运气",
      "压迫感与误解累积，关系维系成本显著上升。",
      "自动互补，冲突会自行消失",
      "只要拖时间就会变成相生"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "相克无连接是高风险组合，需提前干预。"
  },
  {
    "id": "P008",
    "section": "practice",
    "category": "通气判断",
    "text": "一方宫位有四害、另一方无四害，优先提示应是？",
    "options": [
      "四害只影响事业，不影响关系",
      "能量层次不对等，常见“不通气”与沟通失衡。",
      "双方必然快速结婚",
      "说明感情没有任何问题"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "通气首先看双方能量是否对等。"
  },
  {
    "id": "P009",
    "section": "practice",
    "category": "通气判断",
    "text": "双方都有四害时，关系判断更贴近哪种说法？",
    "options": [
      "虽有压力，但“同类”可能增加互相理解，不必草率判离。",
      "四害会自动抵消变大吉",
      "双方有四害一定当天分开",
      "有四害就不需要看共同符号"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "课程强调“同类”概念，断语需保留层次。"
  },
  {
    "id": "P010",
    "section": "practice",
    "category": "脱单实务",
    "text": "单身者明确无对象，合干宫又空亡，较稳妥的结论是？",
    "options": [
      "说明无需再看合干",
      "对象信息多处于“未显化”阶段，需结合应期观察出现窗口。",
      "说明对方已经在身边并立刻领证",
      "说明永远不会有对象"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "空亡多主信息转移或未到位，不宜极端化。"
  },
  {
    "id": "P011",
    "section": "practice",
    "category": "脱单实务",
    "text": "问“何时容易遇到人”，下列哪种取时法更符合课程？",
    "options": [
      "参考合干宫相关地支月份，并结合非填即冲的时间点。",
      "仅看当天心情，不看盘面",
      "只看年支，不看宫位",
      "固定按每月初一断应期"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "脱单应期需结合宫位与空亡触发机制。"
  },
  {
    "id": "P012",
    "section": "practice",
    "category": "婚姻结构",
    "text": "六合临死门且空亡，且当事人尚未婚，通常先提醒什么？",
    "options": [
      "说明双方没有任何现实阻碍",
      "只要有六合就不用看死门",
      "成婚阻力偏大，关系推进容易反复或延后。",
      "必定近期闪婚"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "六合要结合所临门与四害，不能单看“合”。"
  },
  {
    "id": "P013",
    "section": "practice",
    "category": "婚姻结构",
    "text": "配偶宫临直符，直符下临甲，按合干线索应额外关注谁？",
    "options": [
      "己（甲己合），可能提示另一段情缘线索。",
      "庚",
      "壬",
      "乙"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "直符下临干的合干常作另一情缘提示。"
  },
  {
    "id": "P014",
    "section": "practice",
    "category": "婚姻结构",
    "text": "日主与情人信息对宫，咨询时优先提示哪种风险？",
    "options": [
      "对宫只影响财运，不影响情感",
      "关系会自动更稳定",
      "关系更易“撞破”或曝光，隐秘性下降。",
      "说明绝不会被发现"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "对宫结构常放大对抗和显化。"
  },
  {
    "id": "P015",
    "section": "practice",
    "category": "婚姻结构",
    "text": "情人宫空亡时，关系节奏更可能表现为？",
    "options": [
      "断续反复、时有时无，稳定性偏弱。",
      "只会一次性彻底断绝",
      "完全无感情起伏",
      "稳步升温且马上公开"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "空亡典型表现就是“虚、移、难固化”。"
  },
  {
    "id": "P016",
    "section": "practice",
    "category": "事业判断",
    "text": "若开门落震巽并门迫，项目推进判断更偏向？",
    "options": [
      "说明一路畅通可立刻扩编",
      "与事业推进无关",
      "代表只要宣传就能成交",
      "执行阻力较大，流程卡点多，需先排障再扩张。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "开门门迫在事业中常见推进受阻。"
  },
  {
    "id": "P017",
    "section": "practice",
    "category": "事业判断",
    "text": "宣传项目遇“惊门落震巽”门迫，最应警惕什么？",
    "options": [
      "传播必然爆发，越做越顺",
      "说明不用做内容策略",
      "只影响内部财务，不影响发声",
      "传播受阻、口碑噪音和误解风险上升。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "惊门门迫直指发声受阻与流言问题。"
  },
  {
    "id": "P018",
    "section": "practice",
    "category": "事业判断",
    "text": "生门落坎且受克时，商业判断应更谨慎于？",
    "options": [
      "增长与利润兑现节奏偏弱，预期需下调。",
      "代表立刻适合高杠杆扩张",
      "说明只要改Logo即可解决",
      "利润会自动翻倍"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "生门受损常对应增长与收益乏力。"
  },
  {
    "id": "P019",
    "section": "practice",
    "category": "事业判断",
    "text": "签约阶段见“景门落乾兑”门迫，优先动作是？",
    "options": [
      "强化合同审校与表达一致性，防文书前景风险。",
      "先加预算，不看条款",
      "只看对方人情关系即可",
      "忽略文书直接口头成交"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "景门门迫与前景呈现、文书质量密切相关。"
  },
  {
    "id": "P020",
    "section": "practice",
    "category": "事业判断",
    "text": "来访者问“我长期适合做什么”，你优先看？",
    "options": [
      "日干天盘落宫与符号组合",
      "只看六合宫",
      "时干天盘落宫",
      "只看年命，不看盘"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "事业章节对“长期适配”有明确锚点。"
  },
  {
    "id": "P021",
    "section": "practice",
    "category": "事业判断",
    "text": "来访者问“我现在最该选哪条路”，你优先看？",
    "options": [
      "仅看日干不看时干",
      "只看空亡标记",
      "仅看年干",
      "时干天盘落宫与当前组合"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "“当下最优选择”优先由时干承载。"
  },
  {
    "id": "P022",
    "section": "practice",
    "category": "断局流程",
    "text": "起局后最稳妥的流程是？",
    "options": [
      "先看颜值象，再补四纲",
      "先看马星，其他可跳过",
      "先四纲定位，再四害筛查，再定用神读象。",
      "先讲结论，再回头找依据"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "流程顺序稳定，断语才可复核。"
  },
  {
    "id": "P023",
    "section": "practice",
    "category": "择吉实务",
    "text": "做择吉前，关于关键用神宫位最先要确认的是？",
    "options": [
      "是否无四害且能量可用",
      "是否有漂亮文案",
      "是否恰逢周末",
      "是否朋友推荐"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "择吉先过四害底线，避免“带病上场”。"
  },
  {
    "id": "P024",
    "section": "practice",
    "category": "择吉实务",
    "text": "想推进“催结合”，日期策略更符合课程的是？",
    "options": [
      "随便选日期，重点看心情",
      "优先选与意中人（月干）相合的日子再细筛时辰。",
      "固定只选初一十五",
      "只看黄历宜嫁娶即可"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "课程给出“先合后筛”的实操路径。"
  },
  {
    "id": "P025",
    "section": "practice",
    "category": "关系策略",
    "text": "两宫相冲相克时，咨询建议更稳妥的是？",
    "options": [
      "完全断联是唯一方案",
      "必须 24 小时绑定相处",
      "保持适度边界与距离，避免高频硬碰硬。",
      "冲克越强越要快速结婚"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "课程提到“距离产生美”的调节逻辑。"
  },
  {
    "id": "P026",
    "section": "practice",
    "category": "应期速度",
    "text": "用神落内盘并临马星，综合应期更可能是？",
    "options": [
      "只会慢热且无变化",
      "只影响情绪，不影响进度",
      "事件必然拖延很久",
      "事件来得更快，且变动性明显增强。"
    ],
    "correctAnswers": [
      3
    ],
    "explanation": "内盘主近快，马星再加速。"
  },
  {
    "id": "P027",
    "section": "practice",
    "category": "风险分级",
    "text": "同一宫位既见门迫又见击刑，你在报告中应如何定级？",
    "options": [
      "至少按中高风险处理，并提示执行稳定性不足。",
      "可直接判大吉",
      "可按正常宫位处理",
      "只要有吉门就忽略其余"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "双害叠加意味着可用能量显著下降。"
  },
  {
    "id": "P028",
    "section": "practice",
    "category": "风险分级",
    "text": "若上述宫位再叠空亡或入墓，最合适的报告语气是？",
    "options": [
      "明确提示高风险和延迟显化，建议先调结构再推进。",
      "改成激进乐观，鼓励立即重投入",
      "只写“问题不大”即可",
      "不需要给任何行动建议"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "多害叠加接近瘫痪宫，报告需给出稳健策略。"
  },
  {
    "id": "P029",
    "section": "practice",
    "category": "反断应用",
    "text": "当四纲宫位全坏时，下列哪种处理更专业？",
    "options": [
      "直接放弃断局",
      "继续按常规正断，不作任何修正",
      "启动反断思路，同时用现实线索与应期交叉验证。",
      "只凭经验拍结论，不再复核"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "反断不是“反着说”，而是结构化修正。"
  },
  {
    "id": "P030",
    "section": "practice",
    "category": "学业应用",
    "text": "学业预测里，某学科对应天干“克我”，通常先提示什么？",
    "options": [
      "该科压力偏大、状态受阻，需要专项补强。",
      "只要换座位就立刻解决",
      "该科与盘面无关，不用看",
      "该科一定轻松拿高分"
    ],
    "correctAnswers": [
      0
    ],
    "explanation": "“克我”在学业里常见压力与消耗感。"
  },
  {
    "id": "P031",
    "section": "practice",
    "category": "风水应用",
    "text": "做改向或布局时，年命落宫应优先满足哪条底线？",
    "options": [
      "只要装饰好看即可",
      "年命宫位可完全忽略",
      "避免四害，最好与山向宫位形成有利关系。",
      "越多四害越灵验"
    ],
    "correctAnswers": [
      2
    ],
    "explanation": "风水章节强调年命与山向的结构匹配。"
  },
  {
    "id": "P032",
    "section": "practice",
    "category": "咨询边界",
    "text": "对方没问到的敏感内容，专业做法应是？",
    "options": [
      "无论是否相关都强行延展",
      "不主动扩展，先围绕已提问题给出可执行建议。",
      "尽量多讲隐私细节以显示水平",
      "凭直觉补充所有可能事件"
    ],
    "correctAnswers": [
      1
    ],
    "explanation": "课程明确提醒“别人没问的别看别讲”。"
  }
];
